const en = {
  system_settings: {
    class_management: "Class management",
    student_list: "Student list",
    recharge_center: "Subscription",
    help: "Help",
    createCourse: "Create Lesson Plan",
    library: "Legacy Materials",
    setting: "Setting",
    ideaTalk: "Idea Talk",
    ideaSpark: "Idea Present",
    ideaExplore: "Idea Read",
    ideaChallenge: "Idea Quiz",
    ideaActivity: "Idea Activity",
    report: "Idea Report",
    ideaMeet: "Idea Meet",
    ideaWork: "Idea Work"
  }
};
const zh_hant = {
  system_settings: {
    class_management: "班級管理",
    student_list: "學生列表",
    recharge_center: "訂閱中心",
    help: "幫助",
    createCourse: "創建課程",
    library: "舊版課件",
    setting: "系統設置",
    ideaTalk: "Idea Talk",
    ideaSpark: "Idea Present",
    ideaExplore: "閱讀理解",
    ideaChallenge: "問答比賽",
    report: "報告",
    ideaMeet: "智匯研討",
    ideaActivity: "課堂活動",
    ideaWork: "課後作業"
  }
};
const zh_cn = {
  system_settings: {
    class_management: "班级管理",
    student_list: "学生列表",
    recharge_center: "订阅中心",
    help: "帮助",
    createCourse: "创建课程",
    library: "旧版课件",
    setting: "系统设置",
    ideaTalk: "Idea Talk",
    ideaSpark: "Idea Present",
    ideaExplore: "阅读理解",
    ideaChallenge: "问答比赛",
    report: "报告",
    ideaMeet: "智汇研讨",
    ideaActivity: "课堂活动",
    ideaWork: "课后作业"
  }
};

const es = {
  system_settings: {
    class_management: "Gestión de clase",
    student_list: "Lista de estudiantes",
    recharge_center: "Suscripción",
    help: "Ayuda",
    createCourse: "Crear Lección",
    library: "Materiales Antiguos",
    setting: "Configuración",
    ideaTalk: "Idea Talk",
    ideaSpark: "Idea Present",
    ideaExplore: "Idea Read",
    ideaChallenge: "Idea Quiz",
    report: "Idea Report",
    ideaActivity: "Idea Activity",
    ideaMeet: "Idea Meet",
    ideaWork: "Idea Work"
  }
};

export default {
  en,
  zh_hant,
  es,
  zh_cn
};
